// import AdtViewer from './AdtViewer';
import AdtViewWrapper from './AdtViewWrapper';

export default AdtViewWrapper;
